import { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis,
  Tooltip, CartesianGrid,
} from "recharts";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { aggregateGoals } from "../../../lib/progressCompare";
import { ACTIVITY_LABEL_KEYS } from "../../goals/goalRules";

const TOP_LABELS = 8;

// Hedef kimliği ad + biçim; oran tam sayı (ortak döküm).
function aggregateLabelStats(userStats, activityName) {
  return aggregateGoals(userStats, activityName).slice(0, TOP_LABELS);
}

export default function LabelBreakdownChart({ userStats }) {
  const { t } = useScriptMode();
  const data = useMemo(
    () => aggregateLabelStats(userStats, (activity) => t(ACTIVITY_LABEL_KEYS[activity] || activity)),
    [userStats, t]
  );

  if (!data.length) return null;

  return (
    <Box>
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }} mb={2}>
        {t("manage_stats_chart_title")}
      </Typography>
      <Box height={280}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 8, right: 16, bottom: 8, left: 0 }}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip formatter={(v) => `%${v}`} />
            <Bar dataKey="completion" fill="#2E7D62" radius={[6, 6, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </Box>
    </Box>
  );
}
